module.exports = __webpack_public_path__ + "static/media/floor_wooden_silencio.46e0dbf1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/floor_wooden_silencio.png
 ** module id = 959
 ** module chunks = 0
 **/